import { makeHandleProfessionalReport } from 'main/factories/usecases/professional-report/remote-professional-report';
import ProfessionalReport from 'presentation/app/modules/ProfessionalReport/pages';
import React from 'react';

export const MakeProfessionalReport: React.FC = () => {
  return (
    <ProfessionalReport
      handleProfessionalReport={makeHandleProfessionalReport()}
    />
  );
};
